<template>
  <div class="text-xs-center">
    <v-icon large class="orange--text" :style="{fontSize:'53px'}">$vuetify.icons.rms_emoticon_sad</v-icon>
    <div class="subheading mt-2">{{error_messsage}}</div>
    <v-btn color="green" class="mt-3" outline @click="goBack()">Go Back</v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Expired",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      error_messsage: "availLink/getErrorMesssage"
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
